export type CommerceThemeName = "luxury" | "wellness" | "social";

export const commerceThemeTokens = {
    colorPrimary: "--teqtank-color-primary",
    colorOnPrimary: "--teqtank-color-on-primary",
    colorAccent: "--teqtank-color-accent",
    colorOnAccent: "--teqtank-color-on-accent",
    colorBackground: "--teqtank-color-background",
    colorSurface: "--teqtank-color-surface",
    colorSurfaceSoft: "--teqtank-color-surface-soft",
    colorText: "--teqtank-color-text",
    colorTextMuted: "--teqtank-color-text-muted",
    colorBorder: "--teqtank-color-border",
    colorFocus: "--teqtank-color-focus",
    colorSuccess: "--teqtank-color-success",
    colorWarning: "--teqtank-color-warning",
    colorDanger: "--teqtank-color-danger",
    fontHeading: "--teqtank-font-heading",
    fontBody: "--teqtank-font-body",
    fontSizeSmall: "--teqtank-font-size-small",
    fontSizeBody: "--teqtank-font-size-body",
    fontSizeLead: "--teqtank-font-size-lead",
    fontSizeHeadingSmall: "--teqtank-font-size-heading-small",
    fontSizeHeading: "--teqtank-font-size-heading",
    fontWeightNormal: "--teqtank-font-weight-normal",
    fontWeightMedium: "--teqtank-font-weight-medium",
    fontWeightSemibold: "--teqtank-font-weight-semibold",
    fontWeightBold: "--teqtank-font-weight-bold",
    lineHeightTight: "--teqtank-line-height-tight",
    lineHeightBody: "--teqtank-line-height-body",
    letterSpacingEyebrow: "--teqtank-letter-spacing-eyebrow",
    space2xs: "--teqtank-space-2xs",
    spaceXs: "--teqtank-space-xs",
    spaceSm: "--teqtank-space-sm",
    spaceMd: "--teqtank-space-md",
    spaceLg: "--teqtank-space-lg",
    spaceXl: "--teqtank-space-xl",
    space2xl: "--teqtank-space-2xl",
    radiusSmall: "--teqtank-radius-small",
    radiusMedium: "--teqtank-radius-medium",
    radiusLarge: "--teqtank-radius-large",
    radiusPill: "--teqtank-radius-pill",
    shadowSmall: "--teqtank-shadow-small",
    shadowMedium: "--teqtank-shadow-medium",
    shadowLarge: "--teqtank-shadow-large",
    controlHeight: "--teqtank-control-height",
    contentMaxWidth: "--teqtank-content-max-width",
    productImageFit: "--teqtank-product-image-fit",
    motionFast: "--teqtank-motion-fast",
    motionNormal: "--teqtank-motion-normal",
    motionSlow: "--teqtank-motion-slow",
    easingStandard: "--teqtank-easing-standard",
    easingEmphasized: "--teqtank-easing-emphasized",
} as const;

export const commerceComponentTokens = {
    productsColumns: "--teqtank-products-columns",
    productsGap: "--teqtank-products-gap",
    productsCardBackground: "--teqtank-products-card-background",
    productsCardRadius: "--teqtank-products-card-radius",
    productsCardShadow: "--teqtank-products-card-shadow",
    productsMediaAspectRatio: "--teqtank-products-media-aspect-ratio",
    productDetailColumns: "--teqtank-product-detail-columns",
    productDetailGap: "--teqtank-product-detail-gap",
    productDetailMediaBackground: "--teqtank-product-detail-media-background",
    productDetailMediaRadius: "--teqtank-product-detail-media-radius",
    productDetailActionRadius: "--teqtank-product-detail-action-radius",
    enrollmentHeroBackground: "--teqtank-enrollment-hero-background",
    enrollmentHeroColor: "--teqtank-enrollment-hero-color",
    enrollmentCardBackground: "--teqtank-enrollment-card-background",
    enrollmentCardRadius: "--teqtank-enrollment-card-radius",
    enrollmentProductRadius: "--teqtank-enrollment-product-radius",
    enrollmentGridColumns: "--teqtank-enrollment-grid-columns",
    enrollmentGridGap: "--teqtank-enrollment-grid-gap",
    enrollmentOptionColumns: "--teqtank-enrollment-option-columns",
    enrollmentOptionColumnsMedium: "--teqtank-enrollment-option-columns-medium",
    enrollmentOptionColumnsSmall: "--teqtank-enrollment-option-columns-small",
    enrollmentOptionMediaHeight: "--teqtank-enrollment-option-media-height",
    cartBackground: "--teqtank-cart-background",
    cartRadius: "--teqtank-cart-radius",
    cartItemGap: "--teqtank-cart-item-gap",
    cartToolboxWidth: "--teqtank-cart-toolbox-width",
    cartToolboxBackground: "--teqtank-cart-toolbox-background",
    checkoutColumns: "--teqtank-checkout-columns",
    checkoutGap: "--teqtank-checkout-gap",
    checkoutSectionBackground: "--teqtank-checkout-section-background",
    checkoutSectionRadius: "--teqtank-checkout-section-radius",
    checkoutSectionShadow: "--teqtank-checkout-section-shadow",
    checkoutFieldBackground: "--teqtank-checkout-field-background",
    checkoutFieldRadius: "--teqtank-checkout-field-radius",
    checkoutOptionBackground: "--teqtank-checkout-option-background",
    checkoutOptionRadius: "--teqtank-checkout-option-radius",
    checkoutSummaryBackground: "--teqtank-checkout-summary-background",
    checkoutSummaryOffset: "--teqtank-checkout-summary-offset",
    checkoutSummaryBottomGap: "--teqtank-checkout-summary-bottom-gap",
    checkoutSummaryMaxHeight: "--teqtank-checkout-summary-max-height",
    checkoutUpsellBackground: "--teqtank-checkout-upsell-background",
    checkoutUpsellCardRadius: "--teqtank-checkout-upsell-card-radius",
    checkoutUpsellActionRadius: "--teqtank-checkout-upsell-action-radius",
    paymentFrameBackground: "--teqtank-payment-frame-background",
    loginBackground: "--teqtank-login-background",
    loginRadius: "--teqtank-login-radius",
    customerMenuWidth: "--teqtank-customer-menu-width",
    customerMenuBackground: "--teqtank-customer-menu-background",
    marketSelectorMinWidth: "--teqtank-market-selector-min-width",
    marketSelectorBackground: "--teqtank-market-selector-background",
    storefrontBannerBackground: "--teqtank-storefront-banner-background",
    storefrontBannerColor: "--teqtank-storefront-banner-color",
    contactCardBackground: "--teqtank-contact-card-background",
    contactCardRadius: "--teqtank-contact-card-radius",
    affiliateToolsColumns: "--teqtank-affiliate-tools-columns",
    affiliateToolBackground: "--teqtank-affiliate-tool-background",
    sharePanelBackground: "--teqtank-share-panel-background",
    sharePanelRadius: "--teqtank-share-panel-radius",
} as const;

export type CommerceThemeTokenName =
    keyof typeof commerceThemeTokens | keyof typeof commerceComponentTokens;
export type CommerceThemeTokenOverrides = Readonly<Partial<Record<CommerceThemeTokenName, string>>>;

export interface CommerceThemeDefinition {
    readonly name: CommerceThemeName;
    readonly label: string;
    readonly tokens: Readonly<Record<string, string>>;
}

export interface CommerceThemeConfiguration {
    readonly preset?: CommerceThemeName;
    readonly tokens?: CommerceThemeTokenOverrides;
}

export type CommerceTheme = CommerceThemeName | CommerceThemeConfiguration;

const foundation = Object.freeze({
    [commerceThemeTokens.fontSizeSmall]: "0.8125rem",
    [commerceThemeTokens.fontSizeBody]: "1rem",
    [commerceThemeTokens.fontSizeLead]: "1.125rem",
    [commerceThemeTokens.fontSizeHeadingSmall]: "clamp(1.35rem, 3cqi, 2rem)",
    [commerceThemeTokens.fontSizeHeading]: "clamp(2rem, 5cqi, 4rem)",
    [commerceThemeTokens.fontWeightNormal]: "400",
    [commerceThemeTokens.fontWeightMedium]: "500",
    [commerceThemeTokens.fontWeightSemibold]: "600",
    [commerceThemeTokens.fontWeightBold]: "700",
    [commerceThemeTokens.lineHeightTight]: "1.08",
    [commerceThemeTokens.lineHeightBody]: "1.6",
    [commerceThemeTokens.letterSpacingEyebrow]: "0.14em",
    [commerceThemeTokens.space2xs]: "0.25rem",
    [commerceThemeTokens.spaceXs]: "0.5rem",
    [commerceThemeTokens.spaceSm]: "0.75rem",
    [commerceThemeTokens.spaceMd]: "1rem",
    [commerceThemeTokens.spaceLg]: "1.5rem",
    [commerceThemeTokens.spaceXl]: "2rem",
    [commerceThemeTokens.space2xl]: "3rem",
    [commerceThemeTokens.radiusPill]: "999px",
    [commerceThemeTokens.shadowSmall]: "0 0.35rem 1.25rem rgb(20 50 39 / 7%)",
    [commerceThemeTokens.shadowMedium]: "0 1rem 2.5rem rgb(20 50 39 / 10%)",
    [commerceThemeTokens.shadowLarge]: "0 1.6rem 5rem rgb(17 48 36 / 12%)",
    [commerceThemeTokens.controlHeight]: "2.875rem",
    [commerceThemeTokens.contentMaxWidth]: "80rem",
    [commerceThemeTokens.productImageFit]: "contain",
    [commerceThemeTokens.motionFast]: "120ms",
    [commerceThemeTokens.motionNormal]: "200ms",
    [commerceThemeTokens.motionSlow]: "360ms",
    [commerceThemeTokens.easingStandard]: "cubic-bezier(0.2, 0, 0, 1)",
    [commerceThemeTokens.easingEmphasized]: "cubic-bezier(0.2, 0.8, 0.2, 1)",
});

export const commerceThemes: Readonly<Record<CommerceThemeName, CommerceThemeDefinition>> =
    Object.freeze({
        luxury: defineTheme("luxury", "Luxury", {
            [commerceThemeTokens.colorPrimary]: "#1f211d",
            [commerceThemeTokens.colorOnPrimary]: "#ffffff",
            [commerceThemeTokens.colorAccent]: "#8b6a3f",
            [commerceThemeTokens.colorOnAccent]: "#ffffff",
            [commerceThemeTokens.colorBackground]: "#f7f3ec",
            [commerceThemeTokens.colorSurface]: "#fffdf9",
            [commerceThemeTokens.colorSurfaceSoft]: "#eee6d9",
            [commerceThemeTokens.colorText]: "#1f211d",
            [commerceThemeTokens.colorTextMuted]: "#69665f",
            [commerceThemeTokens.colorBorder]: "#d8cec0",
            [commerceThemeTokens.colorFocus]: "#8b6a3f",
            [commerceThemeTokens.colorSuccess]: "#2f6b4f",
            [commerceThemeTokens.colorWarning]: "#8a5b16",
            [commerceThemeTokens.colorDanger]: "#9b2c2c",
            [commerceThemeTokens.fontHeading]: '"Cormorant Garamond", Georgia, serif',
            [commerceThemeTokens.fontBody]: "Inter, ui-sans-serif, system-ui, sans-serif",
            [commerceThemeTokens.radiusSmall]: "0.35rem",
            [commerceThemeTokens.radiusMedium]: "0.75rem",
            [commerceThemeTokens.radiusLarge]: "1.25rem",
        }),
        wellness: defineTheme("wellness", "Wellness", {
            [commerceThemeTokens.colorPrimary]: "#315a47",
            [commerceThemeTokens.colorOnPrimary]: "#ffffff",
            [commerceThemeTokens.colorAccent]: "#728f4f",
            [commerceThemeTokens.colorOnAccent]: "#ffffff",
            [commerceThemeTokens.colorBackground]: "#f2f6ef",
            [commerceThemeTokens.colorSurface]: "#ffffff",
            [commerceThemeTokens.colorSurfaceSoft]: "#e2ece2",
            [commerceThemeTokens.colorText]: "#17261f",
            [commerceThemeTokens.colorTextMuted]: "#5e6d65",
            [commerceThemeTokens.colorBorder]: "#cbd9ce",
            [commerceThemeTokens.colorFocus]: "#315a47",
            [commerceThemeTokens.colorSuccess]: "#26734d",
            [commerceThemeTokens.colorWarning]: "#8a6416",
            [commerceThemeTokens.colorDanger]: "#a33a2b",
            [commerceThemeTokens.fontHeading]: '"DM Serif Display", Georgia, serif',
            [commerceThemeTokens.fontBody]: "Inter, ui-sans-serif, system-ui, sans-serif",
            [commerceThemeTokens.radiusSmall]: "0.75rem",
            [commerceThemeTokens.radiusMedium]: "1.25rem",
            [commerceThemeTokens.radiusLarge]: "2rem",
        }),
        social: defineTheme("social", "Social", {
            [commerceThemeTokens.colorPrimary]: "#352263",
            [commerceThemeTokens.colorOnPrimary]: "#ffffff",
            [commerceThemeTokens.colorAccent]: "#7c3aed",
            [commerceThemeTokens.colorOnAccent]: "#ffffff",
            [commerceThemeTokens.colorBackground]: "#faf7ff",
            [commerceThemeTokens.colorSurface]: "#ffffff",
            [commerceThemeTokens.colorSurfaceSoft]: "#f0e9ff",
            [commerceThemeTokens.colorText]: "#211934",
            [commerceThemeTokens.colorTextMuted]: "#6c617d",
            [commerceThemeTokens.colorBorder]: "#dfd4f2",
            [commerceThemeTokens.colorFocus]: "#7c3aed",
            [commerceThemeTokens.colorSuccess]: "#237a57",
            [commerceThemeTokens.colorWarning]: "#9a6115",
            [commerceThemeTokens.colorDanger]: "#b22f45",
            [commerceThemeTokens.fontHeading]: "Inter, ui-sans-serif, system-ui, sans-serif",
            [commerceThemeTokens.fontBody]: "Inter, ui-sans-serif, system-ui, sans-serif",
            [commerceThemeTokens.radiusSmall]: "0.8rem",
            [commerceThemeTokens.radiusMedium]: "1.1rem",
            [commerceThemeTokens.radiusLarge]: "1.6rem",
        }),
    });

export function applyCommerceTheme(
    theme: CommerceTheme,
    target: HTMLElement = document.documentElement,
): CommerceThemeDefinition {
    const configuration = typeof theme === "string" ? { preset: theme } : theme;
    const preset = configuration.preset ?? "wellness";
    const definition = commerceThemes[preset];
    for (const [property, value] of Object.entries(definition.tokens))
        target.style.setProperty(property, value);
    for (const [token, value] of Object.entries(configuration.tokens ?? {})) {
        if (value === undefined) continue;
        target.style.setProperty(
            resolveThemeToken(token as CommerceThemeTokenName),
            requireTokenValue(value, token),
        );
    }
    target.dataset.commerceTheme = preset;
    return definition;
}

function resolveThemeToken(token: CommerceThemeTokenName): string {
    if (token in commerceThemeTokens)
        return commerceThemeTokens[token as keyof typeof commerceThemeTokens];
    return commerceComponentTokens[token as keyof typeof commerceComponentTokens];
}

function defineTheme(
    name: CommerceThemeName,
    label: string,
    tokens: Readonly<Record<string, string>>,
): CommerceThemeDefinition {
    return Object.freeze({ name, label, tokens: Object.freeze({ ...foundation, ...tokens }) });
}

function requireTokenValue(value: string, token: string): string {
    if (typeof value !== "string" || value.trim().length === 0)
        throw new TypeError(`Theme token '${token}' must be a non-empty CSS value.`);
    return value.trim();
}
